/**
 * Stub: SentimentAnalysisView is not available in the admin app.
 * This stub exists so that @a7y/ui EngineDetailSentiment can be resolved by the bundler.
 */
export const SentimentAnalysisView = () => null;
